export enum MediationKindEnum {
  "一般" = "一般",
  "専任" = "専任",
  "売主" = "売主",
  "仲介" = "仲介",
  "代理" = "代理",
  "専属" = "専属"
}
